<template>
	<div class="info-box">
		<div class="info-menu">
			<div class="info-menu-wrap">
				<ul>
					<li>
						<span class="reply-selected" 
						:class="{'reply-selected-active':infoMenuTag == 'ChatInfoReply'?true:false}"
						@click="modifyInfoTag('ChatInfoReply')">
						</span>
					</li>
					<li v-if="chatFans.type == 1">
						<span class="friend-info" 
						:class="{'friend-info-active':infoMenuTag == 'ChatInfoProfile'?true:false}" 
						@click="modifyInfoTag('ChatInfoProfile')">
						</span>
					</li>
					<li v-if="chatFans.type == 1">
						<span class="friend-moment" 
						:class="{'friend-moment-active':infoMenuTag == 'ChatInfoMoment'?true:false}" 
						@click="modifyInfoTag('ChatInfoMoment')">
						</span>
					</li>
				</ul>
			</div>
		</div>
		<div class="info-container">
			<components :is="infoMenuTag" @reply-click-call="replyClickCall($event)" :chatting="chatting" @recently-modify-call="recentlyModifyCall($event)"></components>
		</div>
	</div>
</template>

<script>
	import ChatInfoReply from './info/ChatInfoReply.vue'
	import ChatInfoProfile from './info/ChatInfoProfile.vue'
	import ChatInfoMoment from './info/ChatInfoMoment.vue'
	
	export default {
		name:'ChatChatTools',
		props:{
			  chatting:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			  }
		},
		data(){
			return {
				infoMenuTag:'ChatInfoReply'
			}
		},
		components:{
			ChatInfoReply,
			ChatInfoProfile,
			ChatInfoMoment
		},
		methods:{
			// 修改info中tag标签
			modifyInfoTag(tag){
				this.infoMenuTag = tag
			},
			
			// 监听快捷语点击
			replyClickCall(val){
				this.$emit('reply-click-call',val)
			},
			
			// 最近聊天修改回调
			recentlyModifyCall(val){
				this.$emit('recently-modify-call',val)
			}
		},
		computed:{
			chatFans(){
				return this.$store.state.chatFans
			}
		},
		watch:{
			chatFans(nVal,oVal){
				if( oVal.type !== undefined && nVal.type !== oVal.type){
					this.infoMenuTag = 'ChatInfoReply'
				}
			}
		}
	}
</script>

<style>
	.info-box{
		width: 300px;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.info-box .info-menu{
		height: 49px;
		border-bottom: 1px solid #CCCCCC;
	}
	.info-menu .info-menu-wrap{
		width: 260px;
		height: 45px;
		padding: 0 20px;
	}
	.info-menu-wrap ul{
		width: 260px;
		height: 45px;
		display: flex;
		flex-direction: row;
		flex-wrap: nowrap;
		align-items: center;
		justify-content: space-around;
	}
	.info-menu-wrap ul li{
		width: 50px;
		height: 45px;
		text-align: center;
		list-style: none;
	}
	.info-menu-wrap span{
		width: 30px;
		height: 30px;
		display: inline-block;
		margin-top: 8px;
		background-image: url(../../assets/img/infoPanel_sprites.png);
		cursor: pointer;
	}
	.info-menu-wrap .reply-selected{
		background-position: -8px -425px;
	}
	.info-menu-wrap .reply-selected-active{
		background-position: -8px -383px;
	}
	.info-menu-wrap .friend-info{
		background-position: -10px -216px;
	}
	.info-menu-wrap .friend-info-active{
		background-position: -10px -174px;;
	}
	.info-menu-wrap .friend-moment{
		background-position: -7px -300px;
	}
	.info-menu-wrap .friend-moment-active{
		background-position: -7px -468px;
	}
	.info-box .info-container{
		position: absolute;
		top: 50px;
		bottom: 10px;
		width: 300px;
	}
</style>
